import React from 'react'
import { Row, Col } from 'react-bootstrap'
import UsersFilterProvider from '../../../providers/users-filter'
import UsersRolescodeFilter from '../users-rolescode-filter'
import UsersSearchStringFilter from '../users-search-string-filter'
import UsersListPaginated from '../../user/paginated-list'
import UserCard from '../../user/card'
import NewUserButton from './add-button'
import FullSplitTemplate from '../../screen-templates/full-split'
import useCurrentUser from '../../../hooks/use-current-user'
import Unauthorized from '../../common/unauthorized'

const UserManager = () => {

    const { isAdmin, isFacilitator } = useCurrentUser()

    if (!isAdmin && !isFacilitator) {
        return (<Unauthorized />)
    }

    return (
        <UsersFilterProvider>
            <FullSplitTemplate>
                <FullSplitTemplate.Main>
                    <Row>
                        <Col>
                            <UsersRolescodeFilter />
                        </Col>
                        <Col className='d-none d-xl-block text-right'>
                            <NewUserButton />
                        </Col>
                        <Col xs={12} className='d-xs-block d-xl-none'>
                            <NewUserButton block />
                        </Col>
                    </Row>
                    
                    <UsersListPaginated userComponent={UserCard} />
                </FullSplitTemplate.Main>
                <FullSplitTemplate.Bar>
                    <UsersSearchStringFilter />
                </FullSplitTemplate.Bar>
            </FullSplitTemplate>
        </UsersFilterProvider>
    )
}

export default UserManager